import React from "react"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
  Cell
} from "recharts"
import { Box, Typography, useTheme } from "@mui/material"

const CustomBar = (props) => {
  const { x, y, width, height } = props
  const radius = 6
  if (height <= 0) return null

  return (
    <path
      d={`M${x},${y + height}
          L${x},${y + radius}
          Q${x},${y} ${x + radius},${y}
          L${x + width - radius},${y}
          Q${x + width},${y} ${x + width},${y + radius}
          L${x + width},${y + height}
          Z`}
      fill={props.fill}
    />
  )
}

const CoverFlowChart = ({ data = [], height = 400 }) => {
  const theme = useTheme()
  const barColor = "#AD916F"

  const chartData = data.map((item) => ({
    time: item.time?.replace(/:00/g, "")?.replace(/ PM| AM/gi, ""),
    covers: item.covers
  }))

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background?.secondary,
        borderRadius: "12px",
        padding: "24px",
        border: `1px solid rgba(173, 145, 111, 0.2)`
      }}>
      <Typography
        variant="h3"
        sx={{
          color: "white",
          textAlign: "center",
          mb: 3,
          textTransform: "uppercase",
          letterSpacing: "2px"
        }}>
        Cover Flow
      </Typography>

      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid
            strokeDasharray="0"
            strokeOpacity={0.15}
            vertical={false}
            stroke="#ffffff"
          />
          <XAxis
            dataKey="time"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#ffffff", fontSize: 13 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#ffffff", fontSize: 13 }}
            domain={[0, "auto"]}
          />
          <Bar dataKey="covers" fill={barColor} barSize={48} shape={<CustomBar />}>
            {chartData.map((entry, index) => (
              <Cell key={index} fill={barColor} />
            ))}
            <LabelList
              dataKey="covers"
              position="top"
              style={{
                fill: "#ffffff",
                fontSize: 14,
                fontWeight: 600
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default CoverFlowChart
